import { useSelector, useDispatch } from "react-redux";
import { setUser, initialState } from "store/auth/userSlice";
import {
  apiLoginUser,
  apiVerifyOtp,
  apiResendOtp
} from "services/AuthService";
import { onSignInSuccess, onSignOutSuccess } from "store/auth/sessionSlice";
import appConfig from "configs/app.config";
import { REDIRECT_URL_KEY } from "constants/app.constant";
import { useNavigate } from "react-router-dom";
import useQuery from "./useQuery";
import { isPartnerPortalDomain } from "utils/portalUtils";

import { useAppMode } from "../../context/AppModeContext";

function useAuth() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const query = useQuery();

  const appMode = useAppMode()

  const { token, signedIn } = useSelector((state) => state.auth.session);

  const signIn = async (values) => {
    const response = await apiLoginUser(values);
    return response.json();
  };

  const verifyOtp = async (values) => {
    const response = await apiVerifyOtp(values);
    return response.json();
  };
  const resendOtp = async (data) => {
    try {
      const res = await apiResendOtp(data);
      const json = await res.json();
      return json;
    } catch (err) {
      console.error("Resend OTP error:", err);
      return { success: false, message: "Failed to resend OTP" };
    }


    return { verifyOtp, resendOtp };
  }

  const handleSignOut = () => {
    dispatch(onSignOutSuccess());
    dispatch(setUser(initialState));
    localStorage.setItem(
      "user",
      JSON.stringify({
        email: "",
        id: null,
        name: "",
        profile_image_url: "",
        tier_id: null,
        username: "",
      })
    );
    const signInPath = appMode === 'partner' ? '/partner/sign-in' : '/sign-in';
    navigate(signInPath);
  };

  const signOut = async () => {
    // await apiSignOut()
    handleSignOut();
  };

  return {
    authenticated: token && signedIn,
    signIn,
    // signUp,
    signOut,
    verifyOtp,
    resendOtp,
  };
}

export default useAuth;
